export const dateFormatInput = 'DD/MM/YYYY';
export const dateFormatOutput = 'DD.MM.YYYY';
